import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from './alert.service';

export interface RegistrationDetails {
  patient_id: string;
  roster_id: string;
}

export interface PracticeDetails {
  client_code: string;
  diary_uuid: string;
}

@Injectable({
  providedIn: 'root',
})
export class RosterPatientService {
  constructor(
    private readonly alert: AlertService,
    private readonly http: HttpClient,
    private readonly translateService: TranslateService,
  ) {}

  getRosterPatient(registrationDetails: RegistrationDetails, practiceDetails: PracticeDetails) {
    return this.http
      .get<{ success: boolean; message: string }>(`/api/roster-patient/${practiceDetails.client_code}/${practiceDetails.diary_uuid}`, {
        params: { ...registrationDetails },
      })
      .pipe(
        catchError((error: unknown) => {
          this.alert.handleErrorDialog$(error, this.translateService.instant('error_getting_roster_patient'));
          return of({ success: false, message: this.translateService.instant('error_getting_roster_patient') });
        }),
      );
  }
}
